import React, { Component } from 'react';
import { connect } from 'react-redux';

import OrderHistoryOrder from './OrderHistoryOrder.jsx';

class OrderHistory extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let oOrderRecords = 'You have no order history.';
    if ( this.props.customer && this.props.customer.order_history && this.props.customer.order_history.length > 0) {
      oOrderRecords = this.props.customer.order_history.map((oOrder, i) => {
        return (
          <OrderHistoryOrder
            key      = {i}
            order    = {oOrder} />
        );
      });
    }

    return (
      <div>
        <h4 className="alt2">Order History</h4>
        <ul className="order-history-list">
          {oOrderRecords}
        </ul>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(OrderHistory);


// WEBPACK FOOTER //
// ./src/components/OrderHistory.jsx